import {type ReactNode, useReducer, type JSX} from 'react'
import {DEFAULT_TAG_COMPONENT_STATE} from './types/default-tag-component-state'
import {tagComponentReducer} from './state/reducer'
import {TagsComponentContext} from './tags-component-context'

type TagsComponentProviderProps = {
    children: ReactNode
}

export function TagsComponentProvider({children}: TagsComponentProviderProps): JSX.Element {
    const [state, dispatch] = useReducer(tagComponentReducer, DEFAULT_TAG_COMPONENT_STATE)

    return <TagsComponentContext value={{state, dispatch}}>{children}</TagsComponentContext>
}
